import React from 'react';

interface DashboardSectionCardProps {
  /** Ícone do header (react-icons/fi), renderizado dentro da caixa 34x34. */
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  /** Badge opcional à direita do header (ex: "sem dados de ad spend"). */
  badge?: React.ReactNode;
  children: React.ReactNode;
  /** Quando true, o corpo vai edge-to-edge (sem padding) — usado por tabelas. */
  flush?: boolean;
  testId?: string;
}

/**
 * Card de seção do dashboard de marketing — espelha o `card_wrap` do mockup
 * `2026-07-18-next-screens/dashboard-marketing.html`: caixa de ícone + título +
 * subtítulo + badge opcional no header, corpo com ou sem padding.
 *
 * Tokenizado (`var(--theme-*)`) — adapta a light/dark.
 */
export const DashboardSectionCard: React.FC<DashboardSectionCardProps> = ({
  icon,
  title,
  subtitle,
  badge,
  children,
  flush = false,
  testId,
}) => (
  <div
    className="rounded-xl overflow-hidden"
    style={{
      backgroundColor: 'var(--theme-card-background)',
      border: '1px solid var(--theme-card-border)',
    }}
    data-testid={testId}
  >
    <div
      className="flex items-center gap-3 px-4 py-3"
      style={{ borderBottom: '1px solid var(--theme-card-border)' }}
    >
      <span
        className="flex items-center justify-center flex-shrink-0"
        style={{
          width: 34,
          height: 34,
          borderRadius: 9,
          backgroundColor: 'var(--theme-page-background)',
          border: '1px solid var(--theme-card-border)',
          color: 'var(--theme-card-text)',
        }}
      >
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <div
          className="font-bold text-base truncate"
          style={{ color: 'var(--theme-card-text)', letterSpacing: '-0.02em' }}
        >
          {title}
        </div>
        {subtitle && (
          <div className="text-xs mt-0.5 truncate" style={{ color: 'var(--theme-muted-text)' }}>
            {subtitle}
          </div>
        )}
      </div>
      {badge && <div className="flex-shrink-0 ml-auto">{badge}</div>}
    </div>
    {flush ? children : <div className="p-4">{children}</div>}
  </div>
);

DashboardSectionCard.displayName = 'DashboardSectionCard';
